import React, { useContext } from 'react';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { useTeamSMSLicense } from 'hooks';

import { CreateTeamContext, actionTypes } from '../createTeamContext';

import { ShadowDom } from './ShadowDom';
import { TableHeader } from './TableHeader';
import { UserRow } from './UserRow';

export const List = () => {
  const {
    createTeamState: { userList = [], isLoading },
    smsEnabled,
    dispatch,
  } = useContext(CreateTeamContext);

  const { availableTeamSMSLicenses, noAvailableLicenses } = useTeamSMSLicense();

  const handleClick = ({ firstName, lastName, nextivaUUID }) => {
    if (noAvailableLicenses) {
      dispatch({ type: actionTypes.SET_NO_LICENSE_MODAL, payload: true });
    } else if (availableTeamSMSLicenses.length === 1) {
      dispatch({
        type: actionTypes.SET_ASSIGN_LICENSE_BODY,
        payload: [{ action: 'ADD', userUuid: nextivaUUID }],
      });
      dispatch({
        type: actionTypes.SET_ASSIGN_LICENSE_MODAL,
        payload: `${firstName} ${lastName}`,
      });
    } else {
      dispatch({
        type: actionTypes.SET_ASSIGN_LICENSE_BODY,
        payload: [{ action: 'ADD', userUuid: nextivaUUID }],
      });
      dispatch({
        type: actionTypes.SET_MULTI_NO_LICENSE_MODAL,
        payload: `${firstName} ${lastName}`,
      });
    }
  };

  const Row = ({ index, style }) => (
    <UserRow
      key={index}
      user={userList[index]}
      style={style}
      handleClick={handleClick}
    />
  );

  return (
    <>
      <TableHeader smsEnabled={smsEnabled} />
      {isLoading && <ShadowDom />}
      <AutoSizer defaultWidth="100%">
        {({ height, width }) => (
          <FixedSizeList
            height={height}
            width={width}
            className="m-user-list"
            itemCount={userList.length}
            itemSize={71}
          >
            {Row}
          </FixedSizeList>
        )}
      </AutoSizer>
    </>
  );
};
